export const extractPathnameFromHref = (href: string) => {
  if (!href) return null;

  const hrefParts = href.split('?')[0].split(window.location.hostname);

  if (hrefParts.length > 1) return hrefParts[1];

  return hrefParts[0];
};
